<template>
  <div>
      <div class="single-chart">
        <svg viewBox="0 0 36 36" class="circular-chart" :class="color">
          <path class="circle-bg"
                d="M18 2.0845
          a 15.9155 15.9155 0 0 1 0 31.831
          a 15.9155 15.9155 0 0 1 0 -31.831"
          />
          <path class="circle"
                :stroke-dasharray="per"
                d="M18 2.0845
          a 15.9155 15.9155 0 0 1 0 31.831
          a 15.9155 15.9155 0 0 1 0 -31.831"
          />
          <text x="18" y="20.35" class="percentage">{{percent}}%</text>
        </svg>
      </div>

<!--      <div class="single-chart">-->
<!--        <svg viewBox="0 0 36 36" class="circular-chart green">-->
<!--          <path class="circle-bg"-->
<!--                d="M18 2.0845-->
<!--          a 15.9155 15.9155 0 0 1 0 31.831-->
<!--          a 15.9155 15.9155 0 0 1 0 -31.831"-->
<!--          />-->
<!--          <path class="circle"-->
<!--                stroke-dasharray="60, 100"-->
<!--                d="M18 2.0845-->
<!--          a 15.9155 15.9155 0 0 1 0 31.831-->
<!--          a 15.9155 15.9155 0 0 1 0 -31.831"-->
<!--          />-->
<!--          <text x="18" y="20.35" class="percentage">60%</text>-->
<!--        </svg>-->
<!--      </div>-->

<!--      <div class="single-chart">-->
<!--        <svg viewBox="0 0 36 36" class="circular-chart blue">-->
<!--          <path class="circle-bg"-->
<!--                d="M18 2.0845-->
<!--          a 15.9155 15.9155 0 0 1 0 31.831-->
<!--          a 15.9155 15.9155 0 0 1 0 -31.831"-->
<!--          />-->
<!--          <path class="circle"-->
<!--                stroke-dasharray="90, 100"-->
<!--                d="M18 2.0845-->
<!--          a 15.9155 15.9155 0 0 1 0 31.831-->
<!--          a 15.9155 15.9155 0 0 1 0 -31.831"-->
<!--          />-->
<!--          <text x="18" y="20.35" class="percentage">90%</text>-->
<!--        </svg>-->
<!--      </div>-->
  </div>
</template>


<script>
export default {
  props: ["percent"],
  created() {

  },
  mounted(){
    this.per = this.percent + ", 100";

    if (this.percent >= 90) {
      this.color = 'green';
    } else if (this.percent >= 80) {
      this.color = 'blue';
    } else if (this.percent >= 50) {
      this.color = 'yellow';
    } else if (this.percent >= 0) {
      this.color = 'red';
    }
  },
  data() {
    return {
      per: "",
      color: ''
    };
  },
}
</script>

<style scoped>


.circular-chart {
  display: block;
  margin: 10px auto;
  max-width: 80%;
  max-height: 250px;
}

.circle-bg {
  fill: none;
  stroke: #eee;
  stroke-width: 3.8;
}

.circle {
  fill: none;
  stroke-width: 2.8;
  stroke-linecap: round;
  animation: progress 1s ease-out forwards;
}

@keyframes progress {
  0% {
    stroke-dasharray: 0 100;
  }
}

.circular-chart.red .circle {
  stroke: #F87171;
}

.circular-chart.green .circle {
  stroke: #34D399;
}

.circular-chart.yellow .circle {
  stroke: #FBBF24;
}

.circular-chart.blue .circle {
  stroke: #60A5FA;
}

.percentage {
  fill: #666;
  font-family: sans-serif;
  font-size: 0.5em;
  text-anchor: middle;
}
</style>
